<script setup>
import StormTrack from '@/components/StormTrack.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <StormTrack />
  </Suspense>
  <ToastHost />
</template>
